<form [formGroup]="form">
  <div mat-dialog-title class="title">
    <div class="subtitle">{{ 'EditBorgScale' | translate }}</div>
  </div>
  <mat-dialog-content>
    <div mat-line class="line">
      <mat-radio-group formControlName="invertedScale" class="flex space-between">
        <mat-radio-button color="primary" [value]="false">{{ 'Progressive' | translate }}</mat-radio-button>
        <mat-radio-button color="primary" [value]="true">{{ 'Inverted' | translate }}</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="line">
      <fieldset>
        <legend>{{ 'Man_scale' | translate }}</legend>
        <ng-container *ngFor="let bound of scaleMale.controls; let i = index;">
          <mat-form-field class="bound-field">
            <mat-label>{{ (i+1) }}</mat-label>
            <input matInput type="number" autocomplete="off" [formControl]="bound" />
            <span matSuffix>{{ unit }}</span>
            <mat-hint align="end">{{ form.controls["invertedScale"].value ? '≤' : '≥' }} {{ bound.value }}</mat-hint>
            <mat-error *ngIf="bound.invalid && bound.touched">{{ 'Field_required' | translate }}</mat-error>
          </mat-form-field>
        </ng-container>
      </fieldset>
    </div>
    <div class="line">
      <fieldset>
        <legend>{{ 'Woman_scale' | translate }}</legend>
        <ng-container *ngFor="let bound of scaleFemale.controls; let i = index;">
          <mat-form-field class="bound-field">
            <mat-label>{{ (i+1) }}</mat-label>
            <input matInput type="number" autocomplete="off" [formControl]="bound" />
            <span matSuffix>{{ unit }}</span>
            <mat-hint align="end">{{ form.controls["invertedScale"].value ? '≤' : '≥' }} {{ bound.value }}</mat-hint>
            <mat-error *ngIf="bound.invalid && bound.touched">{{ 'Field_required' | translate }}</mat-error>
          </mat-form-field>
        </ng-container>
      </fieldset>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="onRemoveClicked()" tabindex="-2">{{ 'Remove' | translate}}</button>
    <button mat-button mat-dialog-close tabindex="-1">{{ 'Cancel' | translate}}</button>
    <button mat-raised-button (click)="submitForm()" color="accent">{{ 'Save' | translate}}</button>
  </mat-dialog-actions>
</form>
